import React from 'react';

const MailSVG = () => (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.5 13.5H1.5C0.948 13.5 0.5 13.052 0.5 12.5V1.5C0.5 0.948 0.948 0.5 1.5 0.5H14.5C15.052 0.5 15.5 0.948 15.5 1.5V12.5C15.5 13.052 15.052 13.5 14.5 13.5Z"
            stroke="black"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.5 3.5L8 8L13.5 3.5"
            stroke="black"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default MailSVG;
